import React from "react";
import { useNavigate } from "react-router-dom";

const Button = ({
  text,
  onClick,
  className = "",
  variant = "primary",
  size = "md",
  link,
  disabled = false,
}) => {
  const navigate = useNavigate();

  const baseStyles =
    "font-semibold rounded-tl-[2rem] rounded-br-[2rem] border border-white transition-all duration-300 ease-in-out shadow-[0_10px_30px_rgba(0,0,0,0.5)] hover:shadow-[0_8px_20px_rgba(0,0,0,0.4)] hover:scale-105";

  const variants = {
    primary: "bg-primary text-white hover:bg-opacity-80",
    secondary: "bg-secondary text-white hover:bg-opacity-80",
    outline:
      "bg-transparent text-black border-black hover:bg-black hover:text-white",
    whitish: "bg-white text-primary hover:bg-opacity-80",
    disabled:
      "bg-gray-400 text-gray-700 cursor-not-allowed shadow-none hover:scale-100",
  };

  const sizes = {
    sm: "px-4 py-2 text-sm sm:px-5 sm:py-2.5",
    md: "px-6 py-3 text-base sm:px-7 sm:py-3.5",
    lg: "px-8 py-4 text-lg sm:px-9 sm:py-5",
  };

  const handleClick = () => {
    if (disabled) return;
    if (link) navigate(link);
    if (onClick) onClick();
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`${baseStyles} ${
        disabled ? variants["disabled"] : variants[variant]
      } ${sizes[size]} ${className}`}
    >
      <span>{text}</span>
    </button>
  );
};

export default Button;
